// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy } from './shared';

export const label = 'Contents - Basic AD';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C12/11000002',
  policyDetailsId: '110000021001',
  forename: 'Albert',
  coverType: 'Contents',
  accidentalDamageLevel: { Buildings: 'None', Contents: 'Basic' }
});
